import React from 'react';
import { profile } from '../data';
import SocialLinks from './SocialLinks';
import '../styles/theme.css';

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-card">
        <div className="hero__grid">
        {/* Text Content */}
        <div>
          <div className="status-badge">open to opportunities</div>
          <p className="hero__meta">
            {profile.role} · {profile.location}
          </p>

            <h2>
              <span>Hi, I'm</span>
            </h2>
            
            <h1 className="hero__title">
              {profile.name.split(' ').map((word, i) => (
                <span key={i}>{word}</span>
              ))}
            </h1>

           {/* <p className="hero__tagline">{profile.tagline}</p> */}

            <div className="hero__actions">
              <a
                href="#experience"
                onClick={e => { e.preventDefault(); document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="btn btn--primary"
              >
                View experience
              </a>
              <a
                href="#contact"
                onClick={e => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="btn btn--secondary"
              >
                Get in touch
              </a>
            </div>

              <SocialLinks />
            </div>

            {/* Profile Image */}
            <div className="hero__image-container">
              <img
                src="/images/Pic.jpg"
                alt={profile.name}
                className="hero__image"
              />
            </div>
          </div>
        </div>

      {/* Scroll Indicator */}
      {/* <p className="hero__scroll">
        <span />
        scroll to explore
      </p> */}
    </section>
  );
}
